// Modal.js
import React from 'react';
import './App.css'; // Create a CSS file for styling if needed

const BoxFolderModal = ({ isOpen, onClose, boxFolderId }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="close-button" onClick={onClose}>
          Close
        </button>
        <div style={{ width: '100%', height: '80vh' }}>
          <iframe
            src={`/boxfolderid.html?boxFolderId=${boxFolderId}`} 
            title="Box Content Explorer"
            style={{ width: '100%', height: '100%', border: 'none' }}
          />
        </div>
      </div>
    </div>
  );
};

export default BoxFolderModal;
